export const distinct = arr => arr.reduce((result, value) =>
  result.includes(value) ? result : [...result, value], []);